import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import { Button } from 'components/base'
import { goToOrganizationUpgrade } from 'data/ui/actions'
import MoveContentImg from './move-content.svg'

class FileLimitExceeded extends React.Component {
  static propTypes = {
    goToOrganizationUpgrade: PropTypes.func.isRequired,
  }

  onClickUpgrade = () => {
    this.props.goToOrganizationUpgrade({ incentiveId: 'FileLimitExceeded' })
  }

  render() {
    const { title, subtitle, illustration } = this.props
    return (
      <div
        className={classNames(
          'slite-design-system flexbox flexbox-column flexbox-align-center',
          illustration
            ? 'padding-bottom-largest padding-left-largest padding-right-largest'
            : 'padding-largest'
        )}
      >
        {illustration && (
          <div
            className="margin-bottom-larger"
            style={{ width: 400, height: 204 }}
          >
            <img src={MoveContentImg} alt="no-space-left" />
          </div>
        )}
        <div className="margin-bottom-larger font-size-larger bold">
          {title}
        </div>
        <div
          className="margin-bottom-larger shade-05"
          style={{ textAlign: 'center' }}
        >
          {subtitle}
        </div>
        <Button.Primary onClick={this.onClickUpgrade}>
          Upgrade Plan
        </Button.Primary>
      </div>
    )
  }
}

export default connect(
  null,
  {
    goToOrganizationUpgrade,
  }
)(FileLimitExceeded)
